import { render, staticRenderFns } from "./ChangeLog.vue?vue&type=template&id=59ab1c79&scoped=true"
import script from "./ChangeLog.vue?vue&type=script&lang=js"
export * from "./ChangeLog.vue?vue&type=script&lang=js"
import style0 from "./ChangeLog.vue?vue&type=style&index=0&id=59ab1c79&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ab1c79",
  null
  
)

export default component.exports